
<template>
    <div ref="trapRef" class="modal" v-if="icon === true">
      <q-card class="pa">
        <q-card-section class="row items-center q-pb-none">
          <q-space />
        <div class="modal-title-icon">
          <q-btn class="q-mb-lg" @click="closeModal" icon="close" flat round dense v-close-popup />
            <h4 class="q-mb-lg">LEED Learning and Teaching Conference 2023</h4>
        </div>
        </q-card-section>
            
        <q-card-section>
          <q-video
            tabindex="1"
            :ratio="16/9"
            
            src="https://cdnapisec.kaltura.com/p/1128062/sp/112806200/embedIframeJs/uiconf_id/27474902/partner_id/1128062?iframeembed=true&playerId=kaltura_player&entry_id=1_1wuvpsgv&flashvars[akamaiHD.loadingPolicy]=preInitialize&amp;flashvars[akamaiHD.asyncInit]=true&amp;flashvars[streamerType]=hdnetwork&amp;flashvars[localizationCode]=en&amp;flashvars[leadWithHTML5]=true&amp;flashvars[sideBarContainer.plugin]=true&amp;flashvars[sideBarContainer.position]=left&amp;flashvars[sideBarContainer.clickToClose]=true&amp;flashvars[chapters.plugin]=true&amp;flashvars[chapters.layout]=vertical&amp;flashvars[chapters.thumbnailRotator]=false&amp;flashvars[streamSelector.plugin]=true&amp;flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&amp;flashvars[dualScreen.plugin]=true&amp;flashvars[hotspots.plugin]=1&amp;flashvars[Kaltura.addCrossoriginToIframe]=true&amp;&wid=1_bil3ym6v"
            />

        </q-card-section>
      </q-card>
    </div>
    <div v-if="icon === true" class="modal-background">

    </div>
</template>

<script setup>

import { ref } from "vue"
import useFocusTrap from "../composables/useFocusTrap";

const { trapRef } = useFocusTrap();

const props = defineProps({icon: Boolean})   
 
const emit = defineEmits(['close'])

const modalOpenClose = true
   

const closeModal = () => {
    emit('close')

    props.icon === true ? modalOpenClose = false : modalOpenClose = true

    console.log('modal comp', props.icon)
}



</script>

<style lang="scss" scoped>



.q-card__section--vert {
    padding: 0 !important;
}
  
</style>